import { TemplateEngineConfigs } from '@bcp-nextgen-dx-touchpoint-framework/react-js';
import { TouchPointHelper } from '../../helpers/touchPointHelper';
import {
	_root,
	requestContact,
	serviceError,
	subscriptionConclusion,
	subscriptionResumeAndAuthorization,
	subscriptionSelectAccount,
	subscriptionSelectPlan,
	subscriptionTermsAndConditionsBank,
	subscriptionTermsAndConditionsSoftware,
	integratedSolutionConclusion,
	integratedSolutionResumeAndAuthorization,
	integratedSolutionSelectAccount,
	integratedSolutionSelectSolution,
	integratedSolutionTermsAndConditionsBank,
	intro,
} from './prisms';

const templateEngineConfigs: TemplateEngineConfigs = {
	metadata: {
		projectInstanceId: 1,
		projectArtifactInstanceId: 1,
		channelTouchPointId: 1,
		channelTouchPointType: null,
		channelTouchPointDefaultOrientation: null,
		channelTouchPointDefaultPreviousPagesQuantity: 0,
		channelTouchPointDefaultNextPagesQuantity: 0,
		formFactorType: null,
		formFactorShape: null,
		formFactorReferenceSize: null,
	},
	uiPrisms: {
		prisms: [
			_root,
			intro,
			requestContact,
			serviceError,
			subscriptionConclusion,
			subscriptionResumeAndAuthorization,
			subscriptionSelectAccount,
			subscriptionSelectPlan,
			subscriptionTermsAndConditionsBank,
			subscriptionTermsAndConditionsSoftware,

			integratedSolutionSelectSolution,
			integratedSolutionSelectAccount,
			integratedSolutionTermsAndConditionsBank,
			integratedSolutionResumeAndAuthorization,
			integratedSolutionConclusion,
		],
	},
	uiModelComponents: TouchPointHelper.getUiModelPlaceholders(),
};

export default templateEngineConfigs;
